import { Text } from 'foundations-components/components/Text';
import { getNewSnippetsUrl, getSnippetsUrl } from 'hubspot-prosemirror/prosemirror/utils/manageLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SnippetsPopoverHeader({
  portalId,
  openUrl
}) {
  const openNewSnippetLinkHandler = () => {
    const url = getNewSnippetsUrl(portalId);
    openUrl(url);
  };
  const openSnippetsLinkHandler = () => {
    const url = getSnippetsUrl(portalId);
    openUrl(url);
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "draftPlugins.snippetsPlugin.popover.header.insertSnippet"
      })
    }), /*#__PURE__*/_jsxs(Box, {
      grow: 0,
      children: [/*#__PURE__*/_jsx(Button, {
        external: true,
        onClick: openSnippetsLinkHandler,
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.manage"
        })
      }), /*#__PURE__*/_jsx(Button, {
        external: true,
        onClick: openNewSnippetLinkHandler,
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.snippetsPlugin.popover.header.createNew"
        })
      })]
    })]
  });
}
SnippetsPopoverHeader.propTypes = {
  portalId: PropTypes.number.isRequired
};
export default SnippetsPopoverHeader;